import { useQuery } from 'react-query';

import { BackendService } from '../services/backendService';

function useGenerateAuthToken() {
  const { data, isFetching, error } = useQuery<{
    token: string;
  }>(['authToken-generate'], () => BackendService.instance.authToken.generate());

  return {
    data,
    isFetching,
    error,
  };
}

export default useGenerateAuthToken;
